/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Box,
  Flex,
  Text,
  Spinner,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
} from '@chakra-ui/react';
import { IPartner } from '../../../../../hooks/useCompanies';
import { toCurrency, formatCPF, formatCNPJ } from '../../../../../utils/FormatFunctions';

interface PartnerTableProps {
  partnerList: (IPartner & {
    empresas_simples?: number;
    empresas_presumido?: number;
  })[];
  isLoading: boolean;
  // eslint-disable-next-line no-unused-vars
  onRowClick: (item: IPartner) => void;
}

const formatCPForCNPJ = (value: string | number | null | undefined): string => {
  if (!value) return '';
  const cleanValue = value.toString().replace(/\D/g, '');

  // CNPJ tem 14 dígitos, CPF tem 11 dígitos
  if (cleanValue.length === 14) {
    return formatCNPJ(value);
  }
  return formatCPF(value);
};

export function PartnerTable({ partnerList, isLoading, onRowClick }: PartnerTableProps) {
  const calculateTotalEmpresas = (item: PartnerTableProps['partnerList'][0]) => {
    return (item.empresas_simples ?? 0) + (item.empresas_presumido ?? 0);
  };

  if (isLoading && partnerList?.length === 0) {
    return (
      <Box bg="white" borderRadius="lg" shadow="sm" overflow="hidden">
        <Flex justify="center" align="center" h="400px">
          <Spinner size="xl" color="blue.500" />
        </Flex>
      </Box>
    );
  }

  if (!isLoading && partnerList?.length === 0) {
    return (
      <Box bg="white" borderRadius="lg" shadow="sm" overflow="hidden">
        <Flex justify="center" align="center" h="400px">
          <Text color="gray.500">Nenhum socio encontrado</Text>
        </Flex>
      </Box>
    );
  }

  return (
    <Box bg="white" borderRadius="lg" shadow="sm" overflow="hidden">
      <TableContainer>
        <Table variant="simple" size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Nome do Socio</Th>
              <Th>CPF/CNPJ</Th>
              <Th isNumeric>T.Empresas</Th>
              <Th isNumeric>Faturamento Acumulado</Th>
            </Tr>
          </Thead>
          <Tbody>
            {partnerList?.map(item => (
              <Tr
                key={item.socio_id}
                _hover={{ bg: 'gray.50' }}
                cursor="pointer"
                onClick={() => onRowClick(item)}
              >
                <Td>
                  <Box>
                    <Text fontWeight="medium" fontSize="sm" noOfLines={1}>
                      {item.nome_socio}
                    </Text>
                  </Box>
                </Td>
                <Td>
                  <Badge colorScheme="gray" fontSize="xs">
                    {formatCPForCNPJ(item.inscricao)}
                  </Badge>
                </Td>
                <Td isNumeric>
                  <Text fontSize="sm" fontWeight="medium" color="gray.700">
                    {calculateTotalEmpresas(item)}
                  </Text>
                </Td>
                <Td isNumeric>
                  <Text fontSize="sm" fontWeight="semibold" color="blue.600">
                    {toCurrency(item.faturamento_acumulado)}
                  </Text>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
}
